import { type Maybe, hasValue } from '@vrplatform/utils';
import type { syncStatus_enum, sync_bool_exp } from '@vrplatform/graphql';

export const whereSyncs = (args: {
  tenantId: string;
  connectionId?: Maybe<string>;
  category?: Maybe<string>;
  search?: Maybe<string>;
  status?: syncStatus_enum[];
  type?: Maybe<string>; // automationId OR "extract"
}): sync_bool_exp => {
  const _orStatus: sync_bool_exp[] = [];

  if (
    args.status?.includes('completed') ||
    args.status?.includes('canceled') ||
    args.status?.includes('failed')
  ) {
    _orStatus.push({
      status: { _in: args.status },
    });
  }

  if (args.status?.includes('queued')) {
    _orStatus.push({
      _or: [
        {
          status: { _eq: 'queued' },
        },
        {
          subtasks: {
            status: { _eq: 'queued' },
          },
        },

        {
          changes: {
            status: { _eq: 'queued' },
          },
        },
      ],
    });
  }
  if (args.status?.includes('started')) {
    _orStatus.push({
      _or: [
        {
          status: { _eq: 'started' },
        },
        {
          subtasks: {
            status: { _eq: 'started' },
          },
        },
      ],
    });
  }

  const _orSearch: sync_bool_exp[] | undefined = args.search
    ? [
        { message: { _ilike: `%${args.search}%` } },
        {
          connection: {
            _or: [
              {
                name: { _ilike: `%${args.search}%` },
              },
              {
                uniqueRef: { _ilike: `%${args.search}%` },
              },
            ],
          },
        },
        {
          user: {
            _or: [
              {
                firstName: { _ilike: `%${args.search}%` },
              },
              {
                lastName: { _ilike: `%${args.search}%` },
              },
            ],
          },
        },
      ]
    : undefined;

  return {
    tenantId: { _eq: args.tenantId },
    automationId:
      args.type === 'extract'
        ? { _is_null: true }
        : args.type
          ? { _eq: args.type }
          : undefined,
    connection:
      args.connectionId || args.category
        ? {
            id: args.connectionId ? { _eq: args.connectionId } : undefined,
            app: args.category
              ? {
                  category: {
                    _eq: args.category,
                  },
                }
              : undefined,
          }
        : {
            appId: { _nin: ['finalytic'] },
          },
    _and: [
      _orSearch
        ? {
            _or: _orSearch,
          }
        : undefined,
      _orStatus.length
        ? {
            _or: _orStatus,
          }
        : undefined,
    ].filter(hasValue),
  };
};
